
export function webpHandle(imgUrl) {
  if (imgUrl && !imgUrl?.startsWith('http')) {
    imgUrl = `${window.yunweiConfig.cdnServer}/${imgUrl}`
  }
  return imgUrl
}